import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { Observable } from 'rxjs';
import { CodeModel } from '../../administration/models/code.model';
import { IBusinessUnit } from '../../models/business-unit.model';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  baseHttpService = inject(BaseHttpService);

  getCodes(codeType: string): Observable<CodeModel[]> {
    return this.baseHttpService.get<CodeModel[]>(`/codes/${codeType}`);
  }

  getBusinessUnit(mcu: string): Observable<IBusinessUnit> {
    return this.baseHttpService.get<IBusinessUnit>(`/business-unit/${mcu}`);
  }
}
